import type { KyInstance } from 'ky';

import qs from 'qs';

import { CommonQueryParams, CommonResponse } from '../common/common.interface';
import { Faq } from './faq.model';

export async function getFaqs(
  httpClient: KyInstance,
  options: CommonQueryParams,
): Promise<CommonResponse<Faq>> {
  const searchParams = qs.stringify(options);

  return await httpClient.get('faqs', { searchParams }).json();
}
